import { useEffect, useState } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useIsLoggedIn } from '../../state';
import { checkAuthStatus } from '../../services';
import { FaBullseye } from 'react-icons/fa6';

const ProtectedRoute = () => {
    const isLoggedIn = useIsLoggedIn();
    const [isChecking, setIsChecking] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    console.log('rendering protectedroute');

    useEffect(() => {
        console.log('calling checkauthstatus from protectedroute');
        checkAuthStatus();
    }, []);

    useEffect(() => {
        if (isLoggedIn === false) {
            navigate('/login', { state: { from: location }, replace: true });
        } else if (isLoggedIn === true) {
            console.log('in ProtectedRoute user is logged in')
            setIsChecking(false);
        }
    }, [isLoggedIn]);

    if (isChecking) {
        return <div>Loading...</div>;
    }

    return <Outlet />;
};

export default ProtectedRoute;
